export default "__VITE_ASSET__Dlmg5K6B__"